import { getExamDetailApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching exam detail by exam ID
 */
export const useExamDetail = (examId: string | undefined) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_EXAM_DETAIL, examId],
    queryFn: () => getExamDetailApi(examId!),
    enabled: !!examId,
  });

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
  };
};
